<div class="alert {{ type ? 'alert-' + type : '' }} mb-2" [style]="style">
  <div *ngIf="customIcon || type" style="width: 25px; margin-right: 0.75rem">
    <aurora-icon [icon]="customIcon ? customIcon : getAlertIcon()" [class.hide]="noIcon"></aurora-icon>
  </div>
  <ng-content></ng-content>
</div>
